import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Set new password", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "d-grid gap-2" }
const _hoisted_6 = { class: "text-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.start || _ctx.criticalError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.criticalError), 1))
      : _createCommentVNode("", true),
    (_ctx.start && !_ctx.criticalError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pass) = $event)),
              placeholder: "New password"
            }, null, 512), [
              [_vModelText, _ctx.pass]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pass2) = $event)),
              placeholder: "Repeat password"
            }, null, 512), [
              [_vModelText, _ctx.pass2]
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SetNewPass && _ctx.SetNewPass(...args))),
                class: "btn btn-primary"
              }, "Set new pass")
            ]),
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.error), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}